<div class="sidebar">
    <div class="sidebar-content">
        <div class="sidebar-header">
            <div class="logo">
                <img src="../assets/app-assets/images/logo/logo-blue.svg" />
            </div>
            <button class="sidebar-toggler" (click)="handleSidebarToggle()">
                <i class="pi pi-angle-left fs-16"></i>
            </button>
        </div>
    
        <div class="layout-menu-wrapper">
            <div class="layout-menu-container">
                <ul class="layout-menu">
                    <ng-container *ngFor="let item of model; let i = index">
                        <li
                            app-menuitem
                            *ngIf="!item.separator"
                            [item]="item"
                            [index]="i"
                            [root]="true"
                        ></li>
                        <li *ngIf="item.separator" class="menu-separator"></li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="sidebar-overlay" (click)="handleSidebarToggle()"></div>